module.exports = __webpack_public_path__ + "img/7a5ac27.png";